import type { OperationStatusResponse } from '../../universal-flow/types';

export type StatusBannerLabels = {
  resultTitle: string;
  providerTitle: string;
};

export type StatusBannerProps = {
  response: OperationStatusResponse;
  labels: StatusBannerLabels;
  visible: boolean;
};

export function StatusBanner({ response, labels, visible }: StatusBannerProps) {
  const { result, provider_result: providerResult } = response;

  if ((result === null || result === undefined) && (providerResult === null || providerResult === undefined)) {
    return null;
  }

  const hasError =
    Number(result?.code) !== 0 && result?.code !== null && result?.code !== undefined;

  const shouldShowProvider =
    providerResult !== null && providerResult !== undefined &&
    (providerResult.code !== result?.code || providerResult.message !== result?.message);

  return (
    <div
      className={`status-banner${hasError ? ' error' : ''}`}
      style={{
        position: 'relative',
        marginTop: visible ? '16px' : '-8px',
        maxHeight: visible ? '240px' : '0',
        overflow: 'hidden',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'all 180ms ease'
      }}
    >
      <div style={{ paddingTop: '4px' }}>
        {result !== null && result !== undefined ? (
          <>
            <h4>
              {labels.resultTitle}: {result.code ?? '—'}
            </h4>
            {result.message !== null && result.message !== undefined && result.message !== '' ? <p>{result.message}</p> : null}
          </>
        ) : null}
        {shouldShowProvider === true ? (
          <>
            <h4>
              {labels.providerTitle}: {providerResult.code ?? '—'}
            </h4>
            {providerResult.message !== null && providerResult.message !== undefined && providerResult.message !== '' && providerResult.message !== result?.message ? (
              <p>{providerResult.message}</p>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
}

